import { render, staticRenderFns } from "./administrators.vue?vue&type=template&id=2a748ef2&scoped=true&"
import script from "./administrators.vue?vue&type=script&lang=js&"
export * from "./administrators.vue?vue&type=script&lang=js&"
import style0 from "./administrators.vue?vue&type=style&index=0&id=2a748ef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a748ef2",
  null
  
)

export default component.exports